import { render, staticRenderFns } from "./cargosTags.vue?vue&type=template&id=40cf069f&scoped=true&"
import script from "./cargosTags.vue?vue&type=script&lang=js&"
export * from "./cargosTags.vue?vue&type=script&lang=js&"
import style0 from "./cargosTags.vue?vue&type=style&index=0&id=40cf069f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cf069f",
  null
  
)

export default component.exports